module.exports = __webpack_public_path__ + "FSAlbert-Light.fe42713399cab62cd46f.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fsAlbert/FSAlbert-Light.ttf
// module id = ../../../../../src/assets/fonts/fsAlbert/FSAlbert-Light.ttf
// module chunks = main